import React from "react";
import './Footer.css'

export const Footer = () => {
    return (
        <div className="footer_contains">
            <p>Copyright © 2022 Guinea Real Estate LLC, Inc. All rights reserved Privacy Terms</p>
        </div>
    );
}